import { createContext, useState, useContext } from 'react';
import { submitCheckout as apiSubmitCheckout } from '../api/payments';

// Create Checkout Context
export const CheckoutContext = createContext();

// Separate rooms surcharge base amount (before tax)
const SEPARATE_ROOMS_SURCHARGE_BASE = 500;

// Base price (USD/no tax) used to derive provincial tax rates from paymentOptions
const BASE_PRICE_NO_TAX = 1997;

// Payment options data
const paymentOptions = {
  canada: {
    alberta: {
      creditCard: 'https://link.waveapps.com/mgz6ea-w8edy7',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    british_columbia: {
      creditCard: 'https://link.waveapps.com/cnv2zu-k74q5a',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    manitoba: {
      creditCard: 'https://link.waveapps.com/y5vyzw-wf5pqq',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    new_brunswick: {
      creditCard: 'https://link.waveapps.com/34g3jr-9g3gjs',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2296.55
    },
    newfoundland: {
      creditCard: 'https://link.waveapps.com/2ng7ea-52mewr',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2296.55
    },
    northwest_territories: {
      creditCard: 'https://link.waveapps.com/yvxre3-chr9gz',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    nova_scotia: {
      creditCard: 'https://link.waveapps.com/jfmrzg-mr8gma',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2276.58
    },
    nunavut: {
      creditCard: 'https://link.waveapps.com/f8fzmy-79wknb',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    ontario: {
      creditCard: 'https://link.waveapps.com/vj86ug-cnqckq',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2256.61
    },
    pei: {
      creditCard: 'https://link.waveapps.com/y732j8-kkm3qj',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2296.55
    },
    quebec: {
      creditCard: 'https://link.waveapps.com/cwb6nh-254vdt',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    saskatchewan: {
      creditCard: 'https://link.waveapps.com/c86ek5-j3tvvc',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    },
    yukon: {
      creditCard: 'https://link.waveapps.com/3xyq2w-fhm9u8',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Peoples Trust Company\nBank Address: 99 Bank Street, Suite 1420, Ottawa, ON, K1P 1H4, Canada\nAccount Name: Creatos Inc.\nAccount #: 200110445033\nAccount Type: Checking\nTransit #: 16001\nInstitution #: 621',
      interac: 'Email: payments@creatos.ca\nSecurity Question: Where are you going?\nAnswer: Thailand',
      amount: 2096.85
    }
  },
  usa: {
    default: {
      creditCard: 'https://link.waveapps.com/3qzjmq-f3uj2d',
      bankTransfer: 'DOMESTIC TRANSFERS ONLY\nBank: Community Federal Savings Bank\nBank Address: 89-16 Jamaica Ave, Woodhaven, NY, 11421, United States\nAccount Name: Creatos Inc.\nAccount Type: Checking\nRouting Number: 026073150\nAccount Number: 8312608908',
      amount: 1997.00
    }
  },
  other: {
    default: {
      creditCard: 'https://link.waveapps.com/3qzjmq-f3uj2d',
      wireTransfer: 'US DOLLAR INTERNATIONAL TRANSFERS\nBank: Community Federal Savings Bank\nBank Address: 89-16 Jamaica Ave, Woodhaven, NY, 11421, United States\nAccount Name: Creatos Inc.\nAccount Type: Checking\nSWIFT/BIC: CMFGUS33\nAccount #: 8312608908',
      amount: 2050.00
    }
  }
};

export const CheckoutProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [customerInfo, setCustomerInfo] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    province: '',
    state: '',
    address: '',
    city: '',
    postalCode: '',
    transferDate: '',
    transferReference: '',
    reference: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Payment options state is now available in the context
  const [paymentOptionsData] = useState(paymentOptions);

  // BOGO pricing state
  const [pricingType, setPricingType] = useState('standard'); // 'standard' | 'bogo'
  const [bogoData, setBogoData] = useState({
    attendee1FirstName: '',
    attendee1LastName: '',
    attendee2FirstName: '',
    attendee2LastName: '',
    accommodationPreference: ''
  });

  // Update customer information
  const updateCustomerInfo = (updates) => {
    setCustomerInfo(prev => ({ ...prev, ...updates }));
  };

  // Update BOGO data
  const updateBogoData = (updates) => {
    setBogoData(prev => ({ ...prev, ...updates }));
  };

  // Calculate separate rooms surcharge with tax
  // Returns { base, tax, total } for the surcharge
  // Tax rate is derived from paymentOptions to ensure consistency (single source of truth)
  const calculateSeparateRoomsSurcharge = (country, region) => {
    const base = SEPARATE_ROOMS_SURCHARGE_BASE;

    if (country === 'canada' && region) {
      // Derive tax rate from paymentOptions amount vs base price (no tax)
      const provincialAmount = paymentOptions?.canada?.[region]?.amount;
      const taxRate = provincialAmount ? (provincialAmount / BASE_PRICE_NO_TAX) - 1 : 0.05;
      const tax = base * taxRate;
      return {
        base,
        tax: Math.round(tax * 100) / 100,
        total: Math.round((base + tax) * 100) / 100
      };
    }

    // For USA and Other, no additional tax on surcharge
    return {
      base,
      tax: 0,
      total: base
    };
  };

  // Calculate payment amount based on location and pricing type
  // pricingOverride allows components to calculate for a specific pricing type without changing state
  // accommodationOverride allows calculating for a specific accommodation preference
  const calculateAmount = (country, region, pricingOverride = null, accommodationOverride = null) => {
    let baseAmount;

    if (country === 'canada') {
      // Get amount from the paymentOptions object based on province
      const provinceOptions = paymentOptionsData?.canada?.[region];
      baseAmount = provinceOptions?.amount || 1500;
    } else if (country === 'usa') {
      baseAmount = paymentOptionsData?.usa?.default?.amount || 1997;
    } else {
      baseAmount = paymentOptionsData?.other?.default?.amount || 1997;
    }

    // Apply BOGO pricing (1.5x for 2 people)
    const effectivePricingType = pricingOverride || pricingType;
    let totalAmount = baseAmount;

    if (effectivePricingType === 'bogo') {
      totalAmount = baseAmount * 1.5;

      // Add separate rooms surcharge if applicable
      const effectiveAccommodation = accommodationOverride !== null ? accommodationOverride : bogoData.accommodationPreference;
      if (effectiveAccommodation === 'separate_rooms') {
        const surcharge = calculateSeparateRoomsSurcharge(country, region);
        totalAmount += surcharge.total;
      }
    }

    return totalAmount;
  };

  // Submit checkout data to API
  // Accepts optional directCustomerData to avoid React state timing issues
  const submitCheckout = async (directCustomerData = null) => {
    setLoading(true);
    setError(null);
    try {
      // Use direct data if provided, otherwise fall back to state
      // This avoids React async state update timing issues
      const customer = directCustomerData || customerInfo;

      // Prepare checkout data - ensuring country is lowercase to match enum values
      const countryLower = (customer.country || '').toLowerCase();

      const checkoutData = {
        customer: {
          firstName: customer.firstName || '',
          lastName: customer.lastName || '',
          email: customer.email || '',
          phone: customer.phone || '',
          country: countryLower,
          // Only include province for Canada, state for USA
          province: countryLower === 'canada' ? (customer.province || '') : null,
          state: countryLower === 'usa' ? (customer.state || '') : null,
          address: customer.address || '',
          city: customer.city || '',
          postalCode: customer.postalCode || ''
        },
        payment: {
          paymentMethod,
          amount: calculateAmount(customer.country, customer.province || customer.state),
          currency: countryLower === 'canada' ? 'CAD' : 'USD',
          transferDate: customer.transferDate || null,
          transferReference: customer.transferReference || null,
          status: 'pending',
          pricingType: pricingType
        },
        // Include BOGO data if pricing type is BOGO
        bogo: pricingType === 'bogo' ? {
          attendee1FirstName: bogoData.attendee1FirstName,
          attendee1LastName: bogoData.attendee1LastName,
          attendee2FirstName: bogoData.attendee2FirstName,
          attendee2LastName: bogoData.attendee2LastName,
          accommodationPreference: bogoData.accommodationPreference
        } : null
      };

      // Log the checkout data for debugging
      console.log('Submitting checkout data:', checkoutData);

      // Make API request using the API service
      const result = await apiSubmitCheckout(checkoutData);
      
      // Update customer info with reference number
      console.log('Received checkout response:', result);
      
      // Store the reference number for display
      updateCustomerInfo({ 
        reference: result.referenceNumber,
        paymentId: result.paymentId
      });
      
      // Move to confirmation step
      setCurrentStep(3);
      
      return result;
    } catch (err) {
      console.error('Checkout error details:', err);
      setError(err.message || 'Failed to process checkout');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Reset checkout form
  const resetCheckout = () => {
    setCurrentStep(0);
    setPaymentMethod(null);
    setCustomerInfo({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      country: '',
      province: '',
      state: '',
      address: '',
      city: '',
      postalCode: '',
      transferDate: '',
      transferReference: '',
      reference: '',
    });
    setPricingType('standard');
    setBogoData({
      attendee1FirstName: '',
      attendee1LastName: '',
      attendee2FirstName: '',
      attendee2LastName: '',
      accommodationPreference: ''
    });
    setError(null);
  };

  // Checkout context value
  const value = {
    currentStep,
    setCurrentStep,
    paymentMethod,
    setPaymentMethod,
    customerInfo,
    updateCustomerInfo,
    submitCheckout,
    resetCheckout,
    loading,
    error,
    calculateAmount,
    calculateSeparateRoomsSurcharge,
    paymentOptionsData,
    // BOGO state and functions
    pricingType,
    setPricingType,
    bogoData,
    setBogoData,
    updateBogoData
  };

  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  );
};

// Custom hook to use checkout context
export const useCheckout = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('useCheckout must be used within a CheckoutProvider');
  }
  return context;
};
